import "./ListSections.scss";
import { ListSectionsProps } from "/Models/Generated/ListSectionsProps";
import CardSection from "../CardSection/CardSection";

const ListSections: React.FC<ListSectionsProps> = ({ heading, items }) => {
  return (
    <div className="list-sections-norad">
      {heading && <h2 className="list-sections-norad__heading">{heading}</h2>}
      <div className="list-sections-norad__items">
        {items && items.map((item, idx) => <CardSection {...item} key={idx} />)}
      </div>
    </div>
  );
};

export default ListSections;
